/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiDialogTitleStyle = (): Components<Theme>["MuiDialogTitle"] => ({
  styleOverrides: {
    root: {
      textAlign: "center",
      padding: 0,
    },
  },
});
